import { useEffect } from 'react'

function NotFound() {
  useEffect(() => {
    window.location.replace('/404.html')
  }, [])

  return null
}

export default NotFound
